<template>
    <div class="ji_fen">
        <div class="top_bar">
            <div class="tab_box">
                <div class="tab_item" v-for="(item, index) in TabList" :key="index" :class="TabCur == index ? 'active_tab' : '' " @click="TabClick(item, index)" >
                    {{ item }}
                </div>
            </div>
            <div class="btn_box">
                <el-button class="shenbao_btn btn" @click="addBiJi">
                    <span>添加 +</span>
                </el-button>
            </div>
        </div>

        <div class="list_box" v-if="list && list.length">
            <div class="list_item" v-for="(item, index) in list" :key="index">
                <div class="left_box">
                    <div class="icon_box">
                        <span class="iconfont icon-biji"></span>
                    </div>
                    <div class="title_box">
                        <div class="title">
                            {{ item.noteTitle }}
                        </div>
                        <div class="content">
                            {{ item.noteContent }}
                        </div>
                        <div class="time">
                            <span class="iconfont icon-shijian"></span>
                            <span>{{ item.createTime }}</span>
                        </div>
                    </div>
                </div>
                <div class="right_box" >
                    <el-button @click="editInfo(item)">
                        <span class="iconfont icon-bianji"  ></span>
                        编辑</el-button>
                    <el-button @click="deleteInfo(item)">
                         <span class="iconfont icon-shanchu" ></span>
                        删除</el-button>
                </div>
            </div>
            <div class="page_box" v-if="list && list.length">
                <el-pagination
                background
                layout="prev, pager, next"
                :current-page="page"
                :page-size="10"
                @current-change="pageChange"
                :total="totalPage * 10">
                </el-pagination>
            </div>
        </div>

        <no-more v-if="list.length == 0"></no-more>

         <!-- 申报dialog -->
        <div class="dialog_model" v-if="DialogShow">
            <div class="dialog_box">
                <div class="dialog_title">
                    <div class="title_name">
                        {{ isShowDetail ? "修改笔记" : "添加笔记" }}
                    </div>
                    <span class="el-icon-close" style="cursor:pointer;" @click="cancelShenBao"></span>
                </div>
                <div class="form_box">
                    <el-form :model="formData" status-icon  ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="标题" prop="pass">
                            <el-input type="text" v-model="formData.noteTitle" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="内容" prop="pass">
                            <el-input type="textarea" :rows="7" v-model="formData.noteContent" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="笔记图片" v-if="isShowDetail && formData.imgs && formData.imgs.length">
                            <div class="img_box" style="width:100%;display:flex;flex-wrap:wrap;" >
                               <div class="imgs" v-for="(item, index) in formData.imgs" :key="index" style="width:148px;height:148px;position:relative;left:0;top:0;margin-right:10px;" >
                                    <img :src="item" alt="" style="width:148px;height:148px;">
                                    <div class="close_box" style="position:absolute;right:0;top:0;width:30px;height:30px;background:#fff;text-align:center;line-height:30px;cursor:pointer;">
                                        <span class="el-icon-close" style="font-size:24px;"  @click="delImgs( index )"></span>
                                    </div>
                               </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="图片上传" prop="pass">
                            <el-upload
                            action="https://jsonplaceholder.typicode.com/posts/"
                            list-type="picture-card"
                            :auto-upload="false"
                            :before-upload="beforeAvatarUpload"
                            :on-change="imgChange"
                            >
                            <i class="el-icon-plus"></i>
                            </el-upload>
                            <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                            </el-dialog>
                        </el-form-item>
                        
                        <el-form-item>
                            
                        </el-form-item>
                    </el-form>
                    <div class="btns_box">
                        <el-button class="sub_btn" @click="submitForm">提交</el-button>
                            <el-button class="cel_btn" @click="cancelShenBao">取消</el-button>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    export default {
        data() {
            return {
                TabList: ["学习笔记"],
                TabCur: 0,
                options: [],
                list: [
 
                ],
                formData: {
                    noteTitle: "",
                    noteContent: "",
                    noteType: "",
                    ext03: []
                },
                DialogShow: false,
                dialogVisible: false,
                dialogImageUrl: "",
                page: 1,
                totalPage: 0,
                isShowDetail: false,
                imgList: [],
            }
        },
        computed: {
            ...mapGetters(['token'])
        },
        mounted () {
            this.getList();
        },
        methods: {
            // 点击tab
            TabClick(item, index) {
                this.TabCur = index
            },
            // 添加笔记
            addBiJi () {
                this.DialogShow = true
            },
            // 关闭dialog
            cancelShenBao () {
                this.DialogShow = false
                this.isShowDetail = false
                this.formData = {}
            },
            // 获取学习笔记列表
            async getList () {
                let { token, page } = this 
                let res = await this.$axios.post("/lencon/pc/person/study_list", { token, page })
                this.list = res.data.res 
                this.totalPage = res.data.totalPage
            },
            // 添加申报
            async submitForm() {
                this.formData.token = this.token 
                let photosStr = ""
                let { imgList } = this 
                let { noteTitle, noteContent, token, ext03, id } = this.formData 
                if ( imgList && imgList.length ) {
                    photosStr = imgList.join(",")
                } else {
                    photosStr = ""
                }
                if ( this.formData.imgs && this.formData.imgs.length && this.isShowDetail  ) {
                    let arr = [ ...imgList, ...this.formData.imgs ]
                    photosStr = arr.join(",")
                }
                if ( !noteTitle ) {
                    return this.$message.error("请输入标题")
                } else if ( !noteContent ) {
                     return this.$message.error("请输入内容")
                }  else {
                    let data = { }
                    if ( id ) {
                        data = { noteTitle, noteContent, noteType:'1',token, ext03: photosStr ,noteId:id }
                    } else {
                        data = { noteTitle, noteContent, noteType:'1',token, ext03: photosStr  }
                    }
                    
                    let res = await this.$axios.post("/lencon/pc/person/saveStudyNotes", data)
                    this.$message.success( res.data.msg )
                    this.getList()
                    this.formData = {}
                    this.DialogShow = false
                }
            },
            // 页码变化
            pageChange ( page ) {
                console.log( page )
                this.page = page 
                this.getList()
            },
            // 删除图片
            delImgs ( index ) {
                this.formData.imgs.splice(index, 1)
            },
            // 编辑信息
            editInfo ( item ) {
                // console.log( item )
                this.formData = item 
                this.DialogShow = true
                this.isShowDetail = true
            },
            // 删除笔记
            deleteInfo ( item ) {

            } ,
            // 上传图片变化
            async imgChange ( file ) {
                console.log( file)
                let file_doc = file.raw 
                let FD = new FormData()
                FD.append("file_name", 'circle')
                FD.append('circle', file_doc)
                let res = await this.$axios.post("/lencon/app/common/upload", FD)
                // console.log( res )
                if ( res.data.code == 1 ) {
                    this.imgList.push( res.data.data[0] )
                }
            },
            // 上传之前
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg' || 'image/jpg' || 'image/png' || 'image/gif';
                // const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG 格式!');
                }
                // if (!isLt2M) {
                //     this.$message.error('上传头像图片大小不能超过 2MB!');
                // }
                return isJPG ;
            }

        },
    }
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #2767c4 ;
    color: #fff;
    
}
</style>

<style lang="scss" scoped>
.btns_box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.ji_fen {
    width: 980px;
    padding: 20px;
    box-sizing: border-box;
    .top_bar {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0;
        border-bottom:1px solid #eeeeee;
        .tab_box {
            display: flex;
            align-items: center;
            font-size: 20px;
            .tab_item {
                width: 120px;
                text-align: center;
                padding-bottom: 10px;
                cursor: pointer;
            }
            .active_tab {
                color: #2767c4 ;
                border-bottom: 2px solid #2767c4 ;
            }
        }
        .btn_box {
            .study_btn {
                background: #EEEEEE;
                border-radius: 5px;
            }
            .shenbao_btn {
                background: #2767c4 ;
                border-radius: 5px;
                color: #fff;
            }
        }
    }
    .list_box {
        width: 100%;
        .list_item {
            width: 100%;
            display: flex;
            align-items: center;
            margin: 30px 0;
            .left_box {
                display: flex;
                align-items: center;
                flex: 1;
                .icon_box {
                    width: 44px;
                    height: 44px;
                    border-radius: 50%;
                    overflow: hidden;
                    background-color: #2767c4 ;
                    text-align: center;
                    line-height: 44px;
                    .iconfont {
                        font-size: 22px;
                        color: #fff;
                    }
                }
                .title_box {
                    width: 600px;
                    overflow: hidden;
                    margin-left: 10px;
                    .title {
                        font-size: 18px;

                    }
                    .content {
                        padding: 10px;
                        font-size: 16px;
                        color: #b3b3b3;
                    }
                    .time {
                        font-size: 14px;
                        color: #bebebe;
                        line-height: 30px;
                    }
                }
                
            }
            .right_box {
                width:200px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .el-button {
                    width: 90px;
                    background-color: #F9E9EA;
                    color: #DA8484;
                }
            }
            .redcolor {
                color: #2767c4 ;
                font-weight: bold;
            }
            .graycolor {
                color: #b3b3b3;
            }
        }
        .page_box {
            text-align: right;
        }
    }

    .dialog_model {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,.3);
        .dialog_box {
            width: 820px;
            height: 735px;
            overflow-y: scroll;
            position: absolute;
            left: 50%;
            top: 50%;
            margin-left: -410px;
            margin-top: -377px;
            background-color: #fff;
            border-radius: 5px;
            // overflow: hidden;
            padding: 20px;
            .dialog_title {
                font-size: 24px;
                font-weight: bold;
                padding-bottom: 20px;
                border-bottom: 2px solid #2767c4 ;
                color: #2767c4 ;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .form_box {
                padding: 20px 0;
                .sub_btn {
                    width: 230px;
                    height: 50px;
                    color: #fff;
                    background-color: #2767c4 ;
                }
                .cel_btn {
                    width: 230px;
                    height: 50px;
                    color: #fff;
                    background-color: #b3b3b3;
                }
            }
        }
    }
    
}
</style>